import api from '../config/axiosConfig';

export const AuthService = {
    login: async ({ documento, password }) => {
        try {
            const response = await api.post('/auth/login', {
                documento,
                password,
                origin: 'web',
            });

            return response.data;
        } catch (error) {
            console.error('Error en AuthService.login:', error);
            throw error;
        }
    },
    recoverPassword: async (documentNumber) => {
        try {
            const response = await api.post('/auth/recover-password', { documentNumber });
            return response.data;
        } catch (error) {
            console.error('Error en AuthService.recoverPassword:', error);
            throw error;
        }
    },
};
